import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import axios from 'axios';
import Footer from '../components/Footer';
import Checkout from './Checkout';
import { AddBox, RemoveCircle, DeleteForeverOutlined, FavoriteBorderOutlined,RemoveShoppingCart, Add, Remove, BorderColorOutlined } from '@mui/icons-material';
// import CartProductTiles from '../components/CartProductTiles';
import { useSelector, useDispatch } from "react-redux";
import { addOne, delCart, delAllProduct,delAllCart } from "../redux/action";
import { Link, useNavigate } from "react-router-dom";
import { CartUpdate } from "../services/CartUpdate";
import { setHeader } from '../services/Headers';
import { Getauth } from '../services/Auth';
import { GetUserRole } from '../services/UserRole'
import { Url } from '../services/Constants';
import toast from 'react-hot-toast';
import { brown} from '@mui/material/colors';
import app from '../firebaseConfig';
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { Oval } from 'react-loader-spinner';
 

  
export default function Cart() {

  const state = useSelector((state) => state.handleCart);
  const dispatch = useDispatch(); 
  const Navigate = useNavigate()

  const [isloader, setIsloader] = useState(false);
  const [cartProducts,setCartProducts] = useState([])
  const [totalprice, setTotalPrice] = useState()
  const [totalQuantity,setTotalQuantity] = useState()
  const [gstValue, setGstValue] = useState({})
  const [iscartAvailable, setIscartAvailable] = useState(false)
  const [address,setAddress] = useState()
  const [keyData, setKeyData] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [grandTotal, setGrandtotal] = useState()
  const [userProfile,setUserProfile] = useState()
  const [isOutOfStock,setIsOutOfStock] = useState()
  const [orderProducts, setOrderProducts] = useState()
  const [orderAddressId, setorderAddressId] = useState()
  const [OrderIds,setOrderIds] = useState()

  

  useEffect(()=>{

    const db = getFirestore(app)
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, "rzpKey")); 
      const items = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // console.log(items[0].key_id)
      // console.log(items[0].key_secret)
      setKeyData(items);
    };

    const userAddress = async()=>{
      if(Getauth()){
        try {
          const result = await axios.get(`${Url}/buyer/addresses`,setHeader())
          const add = result.data.response_data.addresses[0]
          setorderAddressId(add)
          setAddress(`${add.street_address}, ${add.city}, ${add.pincode}, ${add.state}`)
        } catch (error) {
          console.log(error)
        }
      }
      else{

      }
    }


    const getCartData =async() =>{
      if(Getauth){
        try {
          const result = await axios.get(`${Url}/buyer/carts?page=1`,setHeader())
          if(result.data.response_code===200){
            setCartProducts(result.data.response_data.carts)
            setTotalPages(result.data.response_data.total_pages)
          }
        } catch (error) {
          console.log(error)
        }
      }
    }

    
    
    userAddress()
    fetchData()
    getCartData()

  },[state])

  useEffect(()=>{
    // console.log(state,cartProducts)
    const countTotalPrice = async() => {
      let Total = 0; 
      let totalQty=0
      let cartItems=[]
      if(cartProducts.length>0){
          for(let i =1;i<=totalPages;i++){
            try {
              const result = await axios.get(`${Url}/buyer/carts?page=${i}`,setHeader())
              cartItems = await result.data.response_data.carts
              cartItems.forEach((item) => {
                const subTotal = item.discounted_price * item.quantity; 
                Total += subTotal; 
                totalQty+=item.quantity
              });
            } catch (error) {
              console.log(error)
            }
          }
        
      }else if(state && state.length>0){
      
      state.forEach((item) => {
        const subTotal = item.discounted_price * item.quantity; 
        Total += subTotal; 
        totalQty+=item.quantity
      });}
      setTotalPrice(Total.toFixed(2)); 
      setTotalQuantity(totalQty)
      // setGrandtotal(Total.toFixed(2))
    };

    const gstCalculate=async()=>{
      let gstResult = {}
      if(cartProducts.length>0){
        for(let i =1;i<=totalPages;i++){
          try {
            const result = await axios.get(`${Url}/buyer/carts?page=${i}`,setHeader())
            const cartItems = await result.data.response_data.carts
             gstResult = cartProducts.reduce((acc, item) => {
          if (acc[item.gst]) {
            acc[item.gst] += item.discounted_price*item.quantity;
          } else {
            acc[item.gst] = item.discounted_price*item.quantity;
          }
          return acc;
        }, {});
        setGstValue(gstResult)
        let gstTotal =0
        for (const [key, value] of Object.entries(gstResult)) {
          const calculatedGST = (value * key) / 100;
          gstTotal+=calculatedGST
        }
        let a = Number(totalprice)
        setGrandtotal(a+gstTotal)
      } catch (error) {
        console.log(error)
      }
      }
    }else if(state && state.length>0){
        const result = state.reduce((acc, item) => {
          if (acc[item.gst]) {
            acc[item.gst] += item.discounted_price*item.quantity;
          } else {
            acc[item.gst] = item.discounted_price*item.quantity;
          }
          return acc;
        }, {});
        setGstValue(result)
        let gstTotal =0
        for (const [key, value] of Object.entries(result)) {
          const calculatedGST = (value * key) / 100;
          gstTotal+=calculatedGST
        }
        let a = Number(totalprice)
        setGrandtotal(a+gstTotal)
      }
    }

    // const grandTotalCount =()=>{
    //   setGrandtotal(grandTotal)
    // }

 
    countTotalPrice();
    gstCalculate()

  },[cartProducts,state,totalprice])


  //payment process
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);



  useEffect(()=>{
    const profile = async()=>{
    try {
      if(Getauth()){
        const result = await axios.get(`${Url}/buyer/get_profile`, setHeader())
      if(result.data.response_code===200){
        setUserProfile(result.data.response_data)
      }else{
          Navigate("/")
      }
    }
    } catch (error) {
      
    }
  }

  profile()

  },[])


useEffect(()=>{

},[OrderIds])



//add item 
  const addItem = async (product) => {
    try{
      if(product.cart_id){
        setIsloader(true)
        try {
          const cartupdate = {carts:[{id:product.cart_id,quantity:product.quantity+1}]}
          const result = await axios.put(`${Url}/buyer/carts/update_cart`,cartupdate,setHeader())
          if(result.data.response_code===200){
            setCartProducts(result.data.response_data.carts)
            dispatch(addOne(product));
            setIsloader(false)
            // CartUpdate()
          }else{
            toast.error("Something went wrong!")
            setIsloader(false)
          }
        } catch (error) {
          console.log(error)
        }
      }else{
    dispatch(addOne(product));
    // CartUpdate()
  }
 } catch (error) {
      console.error('Error adding product to cart:', error);
  }
};


//remove item
const removeItem = async (product) => {
    if(product.cart_id){
      setIsloader(true)
      try {
        if(product.quantity>1){
        const cartupdate = {carts:[{id:product.cart_id,quantity:product.quantity-1}]}
        const result = await axios.put(`${Url}/buyer/carts/update_cart`,cartupdate,setHeader())
        if(result.data.response_code===200){
          setCartProducts(result.data.response_data.carts)
         dispatch(delCart(product));
         setIsloader(false)

        }else{
          toast.error("Something went wrong!")
          setIsloader(false)
        }
      }else{
        const result = await axios.delete(`${Url}/buyer/carts/remove_cart_item/${product.cart_id}`,setHeader())
        if(result.data.response_code===200){
          dispatch(delCart(product));
          const newcart = await axios.get(`${Url}/buyer/carts?page=${currentPage}`,setHeader())
          if(newcart.data.response_code===204){
            setCartProducts("")
          }else{
            setCartProducts(newcart.data.response_data.carts)
          }
        }
        setIsloader(false)
      }
      } catch (error) {
        console.log(error)
      }

    }else{
    // const a = {...product,addone:"1"}
    dispatch(delCart(product));
    // CartUpdate()
}
};


//delete item
  const dellAllqty=async (product)=>{
      try{
        if(product.cart_id){
          setIsloader(true)
          try {
            const result = await axios.delete(`${Url}/buyer/carts/remove_cart_item/${product.cart_id}`,setHeader())
            if(result.data.response_code===200){
              const newcart = await axios.get(`${Url}/buyer/carts?page=${currentPage}`,setHeader())
              if(newcart.data.response_code===204){
                setCartProducts("")
              }else{
                setCartProducts(newcart.data.response_data.carts)
              }
                toast.success("Product removed from cart.")
                dispatch(delAllProduct(product))
                CartUpdate()
                setIsloader(false)
            }else{
              toast.error("Something went wrong!")
              setIsloader(false)
            }
          } catch (error) {
            console.log(error)
          }
        }else{
          dispatch(delAllProduct(product))
          // CartUpdate()
          toast.success("Product removed from cart.")
        }
      }catch(error){
        console.error( error)
      }

  }


  async function updatCart() {
    try {
      const cartItems = transformToCartItems();
      // const result = await axios.put(`${apiUrl}/api/v1/cart`, cartItems, setHeader);
    } catch (error) {
      
    }
  }


  const checkOutHandle = async ()=>{
    if(Getauth()){
    if(GetUserRole()== "buyer"){
      setIsloader(true)
      try {
      const result = await axios.get(`${Url}/buyer/get_profile`, setHeader())
      if(result.data.response_code===200){
        // setUserProfile(result.data.response_data)
       const productList =  await getOrderProducts()
        
        if(!isOutOfStock){
          const order_id = await placeOrder(productList)
          let amount = (grandTotal*100).toFixed(2)
          try {
            const data = await axios.post("/v1/orders",
              {
                amount: Number(amount), // Amount in smallest currency unit (paise for INR)
                currency: "INR",
                receipt: order_id,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Basic ${btoa(
                    `${keyData[0].key_id}:${keyData[0].key_secret}`
                  )}`,
                },
              }
            );
            if(data.status===200){
              setIsloader(false)
              RazorpayPayment(data.data,order_id)
            }else{
              setIsloader(false)
              toast.error("Something went wrong!")
            }
          } catch (error) {
            console.log(error)
          }
        }else{
          setIsloader(false)
          toast.error("Some of product is out of stock!")
        }
      }
      
      } catch (error) {
        console.log(error)  
      }
    }
  }else{
    toast.error("Please Login To Ckeckout!")
  }

  }

  async function transformToCartItems(){
    let data=localStorage.getItem("cart")
    const newData = JSON.parse(data)
    data=newData.map((product) => {
       const x={productId: product._id, 
        quantity: product.quantity }
        return x;
       })
       return data
  };



  function RazorpayPayment(data,order_id) {
    let isTimeout = false;
    // const handlePayment = async () => {
    //   try {
    //     // Step 1: Create an order
    //     const { data } = await axios.post(
    //       "https://api.razorpay.com/v1/orders", // Razorpay Order API
    //       {
    //         amount: grandTotal * 100, // Amount in smallest currency unit (paise for INR)
    //         currency: "INR",
    //         receipt: `receipt_${Date.now()}`,
    //       },
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           Authorization: `Basic ${btoa(
    //             "rzp_test_I81mevBP3ZMbDS:ianLqbuZgVR0yIHzzMFf2mFZ"
    //           )}`, // Replace with your Razorpay Key ID and Secret
    //         },
    //       }
    //     );}catch(error){}
    //   }

        try {
        // Step 2: Open Razorpay payment modal
        const options = {
          key: keyData[0].key_id, // Replace with your Razorpay Key ID
          amount: data.amount,
          currency: data.currency,
          name: "Tsofie",
          description: "Test Transaction",
          order_id: data.id, // Order ID generated from Razorpay
          handler: function (response) {
            // alert("Payment Successful!");
            toast.success("Payment Succssfull!")
            updateOrderPayment(response,order_id)
            setIsloader(true)
          },
          timeout:180,
          modal: {
            ondismiss: function () {
              if (isTimeout) {
                toast.error("Payment timed out. Please try again!");
              } else {
                toast.error("Payment canceled by the user!");
              }
            }
          },
          prefill: {
            email: userProfile.email,
            contact: userProfile.mobile_number,
          },
          theme: {
            color: "#371300",
          },
        };
  
        const rzp = new window.Razorpay(options);
        
        const timeoutDuration = options.timeout * 1000; // Convert seconds to milliseconds
        const timeoutTimer = setTimeout(() => {
        isTimeout = true;
        }, timeoutDuration);

        rzp.open();

        rzp.on("payment.failed", () => {
          clearTimeout(timeoutTimer); // Avoid false timeout detection
        });
        
      } catch (error) {
        console.error("Error creating Razorpay order:", error.message);
        alert("Failed to initiate payment.");
      }
    
  }
 
 
 
  async function getOrderProducts() {
     
    let outofStock = false
        let order_products = []
        let j=0
         for(let i =1;i<=totalPages;i++){
          try {
            const result = await axios.get(`${Url}/buyer/carts?page=${i}`,setHeader())
            const cartItems = await result.data.response_data.carts
            cartItems.forEach((item) => {
              if(item?.quantity>item?.left_qty || item?.isOutOfStock){
                outofStock=true;
              }
              order_products[j]={product_variant_id:item.product_variant_id,quantity:item.quantity}
              j++
            });
          } catch (error) {
            console.log(error)
          }
        }
        setIsOutOfStock(outofStock)
        setOrderProducts(order_products)


        return order_products;
  }

  async function placeOrder(productList) {
    try {
      let data = {order:{shipping_address_id:orderAddressId.id},order_products:productList}
      const result = await axios.post(`${Url}/buyer/place_order`,data,setHeader())
      if(result.data.response_code===200){
        setOrderIds(result.data.order_ids)
        return result.data.order_ids
        // let a=await something(response)
      }else{
        setIsloader(false)
        toast.error("Something went wrong while placing the order!")
      }
      
    } catch (error) {
      console.error(error);
    }
  }


  // function something(response){
  //   response
  //   return true
  // }



async function updateOrderPayment(response,order_id){

    const data = {transaction_id:response.razorpay_payment_id, is_from_buy:false, order_ids:order_id}
    try {
      const result = await axios.post(`${Url}/buyer/update_order_payment`,data,setHeader())
      if(result.data.response_code===200){
      const newcart = await axios.get(`${Url}/buyer/carts?page=${currentPage}`,setHeader())
      if(newcart.data.response_code===204){
        setCartProducts("")
        dispatch(delAllCart())
      }
      toast.success("Order placed successfully.")
      setIsloader(false)
      Navigate("/profile/order-history") 
      }else{
        toast.error("Something went wrong!")
      }
    } catch (error) {
      console.log(error)
    }

}


  const onPageChange =async (page) => {
    if (page > 0 && page <= totalPages) {
      if(Getauth){
        try {
          const result = await axios.get(`${Url}/buyer/carts?page=${page}`,setHeader())
          if(result.data.response_code===200){
            setCartProducts(result.data.response_data.carts)
          }
        } catch (error) {
          console.log(error)
        }
      }
        setCurrentPage(page);
    }
};

// console.log(state)
  



  return (
    <>
      <div className="Cart-container">
        <div className="Cart-top">
          <Navbar />
        </div>
        <div className="Cart-feed relative bg-red-50 w-[95%] mx-auto min-h-screen rounded-2xl z-10 top-2 mb-32 shadow-xl">
          <div className="feed-title w-[100%] border-b-2 py-[1%] mx-auto " style={{ borderBottom: '1px solid #c3baba' }}>
            <span className="text-amber-950 font-bold font-poppins text-2xl pl-4">MY CART</span>
          </div>
          <div className="feed-containt w-[96%] flex flex-wrap justify-around max-sm:flex-col">
            <div className="feed-left w-[70%] mt-[2%] md:w-[60%] max-sm:mx-auto max-sm:w-[90%]">
  {cartProducts?.length>0?(
  cartProducts?.map((item,index) => {return (
  <div
  key={index}
  className="products bg-white shadow-2xl rounded-2xl mb-3 flex flex-wrap md:flex-nowrap max-sm:flex-col"
  >
  {/* Image Container */}
  <div className="left w-[40%] max-lg:w-[40%] max-sm:w-full flex items-center justify-center relative p-2">
 
    <div className="w-full aspect-[4/3] relative overflow-hidden rounded-xl">
      <img
        src={item.product_image}
        alt="product"
        className="w-full h-full object-cover transition-opacity duration-200 group-hover:opacity-50 rounded-xl"
      />
    </div>
  </div>

  {/* Content */}
  <div className="right mx-[2%] w-full mt-4 md:mt-0">
    {/* Product Name */}
    <div className="product-name w-full text-amber-950 text-2xl font-bold flex flex-wrap items-end cursor-pointer">
      {item.product_name}
      <span className="ml-1 font-medium text-base">({item.product_code})</span>
    </div>

    <div className="product-bottom mt-[1%] w-full flex items-center max-sm:flex-col max-sm:items-start">
      <div className="price-container w-full cursor-default mt-5">
        {/* Price Display */}
        <div className="price mb-3">
          <span className="font-bold text-lg">Rs. {item.discounted_price}</span>
          <span className="text-sm ml-3">GST - {item.gst}%</span>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between w-full flex-wrap gap-2">
          <div className="left-button flex items-center">
            <Remove
              className="cursor-pointer bg-red-50"
              onClick={() => removeItem(item)}
            />
            <span className="rounded-sm px-4 mx-3 cursor-default font-semibold text-amber-950">
              {item.quantity}
            </span>
            <Add
              className="cursor-pointer bg-red-50"
              onClick={() => addItem(item)}
            />
          </div>

          <div className="product-buttons text-right">
            <span
              className="remove-button rounded-md p-2 outline-none bg-amber-950 text-white hover:bg-amber-900"
              onClick={() => dellAllqty(item)}
            >
              Remove
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
            )}))
            :state && state.length > 0 ? (
             state.map((item,index) => {return (
              <div key={index} className="products bg-white p-[2%] shadow-2xl rounded-2xl mb-3 flex flex-wrap md:flex-nowrap max-sm:flex-col">
  {/* Image Container */}
  <div className="left w-[30%] max-lg:w-[30%] max-sm:w-full flex items-center justify-center relative">
    
    <div className="w-full aspect-[4/3] max-sm:aspect-[3/2] relative overflow-hidden">
      <img
        src={item.product_image}
        alt="product"
        className="w-full h-full object-cover transition-opacity duration-200 group-hover:opacity-50 rounded-xl"
      />
    </div>
  </div>

  {/* Content */}
  <div className="right mx-[2%] w-full mt-4 md:mt-0">
    <div className="product-name w-[90%] text-amber-950 text-2xl font-bold flex flex-wrap items-end cursor-pointer">
      {item.product_name}
      <span className="ml-1 font-medium text-base">({item.product_code})</span>
    </div>

    <div className="product-bottom mt-[1%] w-full flex items-center max-sm:flex-col max-sm:items-start">
      <div className="price-container w-full cursor-default mt-5">
        <div className="price mb-3">
          <span className="font-bold text-lg">Rs. {item.discounted_price}</span>
          <span className="text-sm ml-3">GST - {item.gst}%</span>
        </div>

        <div className="flex justify-between w-full flex-wrap gap-2">
          <div className="left-button flex items-center">
            <Remove
              className="cursor-pointer bg-red-50"
              onClick={() => removeItem(item)}
            />
            <span className="rounded-sm px-[10%] mx-[5%] cursor-default font-semibold text-amber-950">
              {item.quantity}
            </span>
            <Add
              className="cursor-pointer bg-red-50"
              onClick={() => addItem(item)}
            />
          </div>

          <div className="product-buttons text-right max-sm:mr-3">
            <span
              className="remove-button rounded-md p-2 outline-none bg-amber-950 text-white hover:bg-amber-900 hover:text-white"
              onClick={() => dellAllqty(item)}
            >
              Remove
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
            )}))
            :(
            <div className="no-product flex flex-col justify-center min-h-screen text-gray items-center">
              <RemoveShoppingCart sx={{fontSize:100}} className='opacity-50' />
              <span className='opacity-50' >Your cart is empty!</span>
              <div className="k p-2 text-white bg-amber-950 my-2 rounded-lg cursor-pointer max-sm:text-sm" onClick={()=>Navigate("/")}>Continue Shopping</div>
            </div>)
            }

            {/* pagination */}
            {totalPages>1?<div className="flex justify-between items-center mt-4 mb-4">
        <span className="text-sm text-gray-600">
          Page {currentPage} of {totalPages}
        </span>
        <div className="flex gap-2">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded disabled:opacity-50"
          >
            &laquo;
          </button>
          {
            Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                onClick={() => onPageChange(index + 1)}
                className={`px-3 py-1 rounded ${currentPage === index + 1 ? 'bg-amber-950 text-white' : 'bg-gray-200 hover:bg-gray-300'
                  }`}
              >
                {index + 1}
              </button>
            ))}
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded disabled:opacity-50"
          >
            &raquo;
          </button>
        </div>
            </div>:""}
            </div>



            {state && state.length!==0||cartProducts?.length>0?<div className="feed-right w-[25%] my-[2%] md:w-[35%] max-sm:w-[90%] max-sm:mx-auto">
              {/* Desktop Cart Summary */}
              <div className="bg-white rounded-xl shadow-2xl p-3">
                <div className="right-top text-start pb-2 text-xl text-amber-950 font-medium border-b-2 border-b-red-50">
                  CART SUBTOTAL
                </div>
                <div className="right-center mt-3 pb-3 flex justify-between px-2 border-b border-b-amber-950">
                <span className="k text-amber-950 font-bold  ">Subtotal</span>
                  <span className="k text-amber-950 font-semibold">{totalprice}</span>
                </div>
                {Getauth() && (
                  <div className="address flex justify-between border-b px-2 border-b-amber-950 pb-3 mt-3">
                    <div className="left flex flex-col justify-between">
                      <span className="k text-amber-950 font-bold ">Shipping</span>
                      <BorderColorOutlined className='text-amber-950 cursor-pointer' onClick={() => Navigate("/profile/user")} />
                    </div>
                    <div className="right flex flex-col w-36 items-end">
                      <span className="k text-amber-950 mb-2">Shipping to</span>
                      <span className="k text-end text-amber-950">{address?address:"Please add address"}</span>
                    </div>
                  </div>
                )}
                <div className="flex justify-between px-2  pb-3 mt-3">
                    <span className='text-amber-950 font-bold'>Total Price</span>
                    <span className="text-amber-950 font-semibold"> {totalprice}</span>
                  </div>
                  <div className="flex justify-between px-2 pb-3">
                    <span className='text-amber-950 font-bold'>Qty</span>
                    <span className="text-amber-950 font-semibold"> {totalQuantity}</span>
                  </div>
                  <div className="k text-amber-950 px-2 font-bold mb-2">GST</div>
                  <div className="gstdata border-b border-b-amber-950 mb-2">
                  {Object.entries(gstValue).map(([key, value]) =>{ 
                    const calculatedGST = (value * key) / 100;
                    return (
                  <div key={key} className="flex justify-between px-2">
                  <span className="text-amber-950 font-semibold">{key}%</span>
                  <span className="text-amber-950 font-semibold">{calculatedGST.toFixed(2)}</span>
                  </div>
                  )})}
                  </div>
                  <div className="flex justify-between px-2 pb-3">
                    <span className='text-amber-950 font-bold'>Grand Total</span>
                    <span className="text-amber-950 font-semibold"> {grandTotal}</span>
                  </div>
                <div className="right-bottom">
                  <div className="checkout-btn w-[80%] text-center mx-auto py-[2%] shadow-md cursor-pointer shadow-gray-500 rounded-lg bg-amber-950 text-white hover:bg-amber-900" onClick={checkOutHandle}>
                    Proceed To Checkout
                  </div>
                </div>
              </div>
            </div>:""}
          </div>

          
        </div>
        <div className="Cart-bottom mb-0">
          <Footer />
        </div>
          {isloader?<div className='fixed inset-0 z-50 bg-gray-200 bg-opacity-50 flex justify-center items-center'>
        <Oval
        visible={true}
        height="80"
        width="80"
        color="#995500"
        ariaLabel="oval-loading"
        wrapperStyle={{}}
        wrapperClass=""
        secondaryColor='none'
        strokeWidth={3}
        />
        </div>:""}
      </div>
      
    </>
  );
}
